import PropTypes from 'prop-types';
import React from 'react';

const blockScreenClass = isScreenBlocked => `${isScreenBlocked ? ' block-screen' : ''}`;

const greyOutScreenClass = isGreyedOut => `${isGreyedOut ? ' disabled-measure' : ''}`;

const CommonLayout = props => (
    <div
        className={`assessment-window ${props.class}
                       ${blockScreenClass(props.isScreenBlocked)}
                       ${greyOutScreenClass(props.isGreyedOut)}`}
    >
        {props.children}
    </div>
);

CommonLayout.propTypes = {
    class: PropTypes.string,
    children: PropTypes.node,
    isScreenBlocked: PropTypes.bool,
    isGreyedOut: PropTypes.bool,
};

CommonLayout.defaultProps = {
    class: '',
    children: undefined,
    isScreenBlocked: false,
    isGreyedOut: false,
};

export default CommonLayout;
